"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCorrectMessage = exports.StyledOtherTextInputWrapper = exports.StyledOtherOptionContainer = exports.StyledOption = exports.StyledOptionsContainer = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var utilsOolib_1 = require("../../utilsOolib");
var Typo_1 = require("../Typo");
var themes_1 = require("../../themes");
var mixins_1 = require("../../themes/mixins");
var green = themes_1.colors.green, greyColor80 = themes_1.colors.greyColor80, white = themes_1.colors.white, greyColor100 = themes_1.colors.greyColor100;
exports.StyledOptionsContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  gap: ", ";\n  align-items: center;\n\n  ", "\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  gap: ", ";\n  align-items: center;\n\n  ", "\n"])), function (_a) {
    var S = _a.S;
    return S ? '0.7rem 1.5rem' : '1rem 2rem';
}, function (_a) {
    var listType = _a.listType;
    return listType === 'vertical' ? (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    flex-wrap: nowrap;\n    \n      flex-direction: column;\n      gap: ", ";\n      align-items: flex-start; //ensures that each option doesnt stretch full width and create unnecessary click area\n    "], ["\n    flex-wrap: nowrap;\n    \n      flex-direction: column;\n      gap: ", ";\n      align-items: flex-start; //ensures that each option doesnt stretch full width and create unnecessary click area\n    "])), function (_a) {
        var S = _a.S;
        return S ? '1rem' : '1.5rem';
    }) :
        '';
});
exports.StyledOption = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  position: relative;\n  cursor: ", ";\n  \n\n  &:hover .btn {\n    ", "\n  }\n\n"], ["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  position: relative;\n  cursor: ", ";\n  \n\n  &:hover .btn {\n    ", "\n  }\n\n"])), function (_a) {
    var S = _a.S;
    return S ? '0.7rem' : '1rem';
}, function (_a) {
    var rightWrongResult = _a.rightWrongResult, disabled = _a.disabled;
    return disabled ? 'not-allowed' :
        rightWrongResult ? 'initial' : 'pointer';
}, function (_a) {
    var isSelected = _a.isSelected, rightWrongResult = _a.rightWrongResult, disabled = _a.disabled, theme = _a.theme, invert = _a.invert;
    return !isSelected && !rightWrongResult && !disabled && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background: ", ";\n    "], ["\n      background: ", ";\n    "])), invert ? greyColor80 : (0, utilsOolib_1.getPrimaryColor10)(theme.colors));
});
exports.StyledOtherOptionContainer = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  gap: 1rem;\n  flex-direction: ", ";\n"], ["\n  display: flex;\n  gap: 1rem;\n  flex-direction: ", ";\n"])), function (_a) {
    var listType = _a.listType;
    return listType == 'vertical' ? 'column' : 'row';
});
exports.StyledOtherTextInputWrapper = styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  \n  margin-right: 0.5rem;\n  ", "\n\n  ", ";\n  \n  ", "{ width: 28rem; }\n"], ["\n  \n  margin-right: 0.5rem;\n  ", "\n\n  ", ";\n  \n  ", "{ width: 28rem; }\n"])), function (_a) {
    var rightWrongResult = _a.rightWrongResult;
    return rightWrongResult && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["pointer-events: none;"], ["pointer-events: none;"])));
}, function (_a) {
    var listType = _a.listType;
    return listType === 'vertical' ? (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["margin-left: 2.5rem;"], ["margin-left: 2.5rem;"]))) : (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["width: 28rem"], ["width: 28rem"])));
}, (0, mixins_1.mediaQuery)('sm'));
exports.StyledCorrectMessage = (0, styled_components_1.default)(Typo_1.SANS_3)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  color: ", ";\n  padding-top: 1rem;\n"], ["\n  color: ", ";\n  padding-top: 1rem;\n"])), function (_a) {
    var invert = _a.invert;
    return invert ? white : greyColor100;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
